export default {"src":"/_next/static/media/stressMotivationMobile.3ed9bbb5.svg","height":233,"width":272,"blurWidth":0,"blurHeight":0};